import { render, staticRenderFns } from "./gpd-usd-phone.vue?vue&type=template&id=307f679d&scoped=true&"
import script from "./gpd-usd-phone.vue?vue&type=script&lang=js&"
export * from "./gpd-usd-phone.vue?vue&type=script&lang=js&"
import style0 from "./gpd-usd-phone.vue?vue&type=style&index=0&id=307f679d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307f679d",
  null
  
)

export default component.exports